module.exports = __webpack_public_path__ + "static/media/no-content-lesson.27c6300f.png";